import { takeLatest } from 'redux-saga/effects';
import {
  getChargeRateListSuccess, getChargeRateListFail,
  getChargeRateDetailsSuccess, getChargeRateDetailsFail
} from './chargeRateState';
import createCrudService from '../../services/crudservice';
import { 
	doCrudCall, SAVING_MSG, UPDATING_MSG, DELETING_MSG, LOADING_MSG,
	createRecordSuccess, updateRecordSuccess, deleteRecordSuccess
} from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/clients');
const redirectData = {route:'/console/charge-rates', mode: 'list', recordId:0 };
const modelName = 'ChargeRate';
const modelId = 'cra_id';

function* getChargeRateList(data) {
	yield doCrudCall(
		() => crudService.getList(data.payload), 
		getChargeRateListSuccess, 
		getChargeRateListFail, null, null, LOADING_MSG);
}

function* getChargeRateDetails(data) {
	yield doCrudCall(
		() => crudService.getDetails(data.payload), 
		getChargeRateDetailsSuccess, 
		getChargeRateDetailsFail, null, null, LOADING_MSG);		
}

function* doChargeRateCreate(data){
	yield doCrudCall(
		() => crudService.doCreate(data.payload), 
		getChargeRateDetailsSuccess, 
		getChargeRateDetailsFail,
		createRecordSuccess(modelName),
		redirectData, SAVING_MSG);
}

function* doChargeRateUpdate(data){
	yield doCrudCall(
		() => crudService.doUpdate(data.payload[modelId], data.payload), 
		getChargeRateDetailsSuccess, 
		getChargeRateDetailsFail,
		updateRecordSuccess(modelName),
		redirectData, UPDATING_MSG);	
}

function* doChargeRateDelete(data){
	yield doCrudCall(
		() => crudService.doDelete(data.payload.recordId), 
		getChargeRateDetailsSuccess, 
		getChargeRateDetailsFail,
		deleteRecordSuccess(modelName),
		{...redirectData, mode: data.payload.mode},
		DELETING_MSG);	
}

function* chargeRateSaga() {
  yield takeLatest('chargeRate/getChargeRateList', getChargeRateList);
  yield takeLatest('chargeRate/getChargeRateDetails', getChargeRateDetails);
  yield takeLatest('chargeRate/doChargeRateCreate', doChargeRateCreate);
  yield takeLatest('chargeRate/doChargeRateUpdate', doChargeRateUpdate);
  yield takeLatest('chargeRate/doChargeRateDelete', doChargeRateDelete);  
}

export default chargeRateSaga;
